module.exports = __webpack_public_path__ + "static/media/phone_in_lap_sell.57e30339.png";